import BaseComponent from './_BaseComponent'




/* ACCORDION
----------------------------------------------------------------------------------------------------*/

export default class Accordion extends BaseComponent {

    constructor($el, namespace) {
        super('Accordion', $el, namespace)

        this.hasOpenSection = false
        this.activeClass    = 'is-expanded'
        this.triggerEvents  = ['click']

        this.events = [
            [this.$utils.doc, 'layoutChange', () => { this.onResize() }],
            [this.$utils.doc, 'keydown', (e) => { this.onKeyDown(e) }],
        ]


        this.getSections()
        this.on()
    }




    /* Handlers
    --------------------------------------------------------- */

    onResize() {
        this.applyHeights()
    }


    onToggleClick(e, section) {
        e.preventDefault()

        this.toggleSection(section, !section.isExpanded)
    }


    onKeyDown(e) {
        if (!['ArrowUp', 'ArrowDown'].includes(e.key)) return

        const { length } = this.sections
        const activeIndex = this.sections.findIndex(({ $toggleBtn }) => {
            return document.activeElement === $toggleBtn
        })

        if (activeIndex < 0) return

        e.preventDefault()

        let nextIndex = (activeIndex === length - 1) ? 0 : activeIndex + 1

        if (e.key === 'ArrowUp') {
            nextIndex = (activeIndex === 0) ? length - 1 : activeIndex - 1
        }

        this.sections[nextIndex].$toggleBtn.focus()
    }




    /* Actions
    --------------------------------------------------------- */

    toggleSection(s, shouldExpand = !s.isExpanded) {
        if (s.isExpanded === shouldExpand) return

        clearTimeout(this.toggleTimer)

        s.$el.classList.toggle(this.activeClass, shouldExpand)
        s.$toggleBtn.setAttribute('aria-expanded', shouldExpand)

        s.isExpanded = shouldExpand

        this.hasOpenSection = this.sections.some(sec => sec.isExpanded)

        this.toggleTimer = setTimeout(() => {
            this.$utils.doc.trigger('contentChange')
        }, 700)
    }


    applyHeights() {
        this.sections.forEach(({ $region, $content }) => {
            $region.style.height = `${$content.offsetHeight}px`
        })
    }




    /* Values
    --------------------------------------------------------- */

    getSections() {
        if (!this.$refs.section) return

        this.sections = this.$refs.section.map(($el, i) => ({
            $el,
            $toggleBtn: this.$refs.toggleBtn ? this.$refs.toggleBtn[i] : null,
            $region: this.$refs.region ? this.$refs.region[i] : null,
            $content: this.$refs.content ? this.$refs.content[i] : null,
            isExpanded: false,
        }))

        this.sections.forEach((s) => {
            this.triggerEvents.forEach((ev) => {
                this.bindListener(s.$toggleBtn, ev, (e) => { this.onToggleClick(e, s) })
            })
        })

        this.applyHeights()
    }

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



